import { FormControl, FormLabel } from "@mui/joy";
import { useEffect, useState } from "react";
import { FileUpload } from "primereact/fileupload";
import { Avatar } from "primereact/avatar";
import { Image } from "primereact/image";
import { s3GetUrl, s3UploadFile } from "../service/s3Service";
import { placeholder } from "../assets/placeholder";

interface inputPrams {
  label?: string;
  path: string;
  file?: string;
  setFile?: React.Dispatch<File>;
  setGlobalLoader: React.Dispatch<React.SetStateAction<boolean>>;
  allowUpload?: boolean;
}

export default function S3ImagePreview({ allowUpload = true, ...prams }: inputPrams) {
  const [loading, setLoading] = useState(false);
  const [s3Url, setS3Url] = useState(placeholder);

  const altUrl = placeholder;

  const onUpload = async (event: any) => {
    console.log("event == ", event);
    const file: any = event.files[0];
    setS3Url(file.objectURL);
    prams.setGlobalLoader(true);
    await s3UploadFile(prams.path, file);
    if (prams.setFile) {
      prams.setFile(file);
    }
    prams.setGlobalLoader(false);
  };

  const getUrl = async () => {
    if (!loading) {
      setLoading(true);
      const url = await s3GetUrl(prams.path);
      if (!!url) {
        setS3Url(url);
      }
    }
  };

  useEffect(() => {
    getUrl();
  }, []);

  return (
    <FormControl className="s3-preview" sx={{ flexGrow: 1 }}>
      <Image src={s3Url} alt={altUrl} width="100%" preview />
      {allowUpload && (
        <>
          <br />
          <FileUpload
            auto
            customUpload
            chooseLabel={prams.label || "Select Image"}
            style={{ width: "100%" }}
            mode="basic"
            name="demo[]"
            accept="image/*"
            uploadHandler={onUpload}
          />
        </>
      )}
    </FormControl>
  );
}
